// Configuración del entorno
const config = {
  // URL de la API
  API_URL: process.env.REACT_APP_API_URL || 'https://tzlgf3yf2e.execute-api.us-east-1.amazonaws.com/dev',
  
  // Entorno
  ENV: process.env.REACT_APP_ENV || 'development',
  
  // Feature flags
  ENABLE_DEBUG: process.env.REACT_APP_ENABLE_DEBUG === 'true',
  ENABLE_PROPERTY_CARD_OCR: ['true', '1', 'yes', 'on'].includes(String(process.env.REACT_APP_ENABLE_PROPERTY_CARD_OCR || '').trim().toLowerCase()),
  ENABLE_OFFICIAL_RECORDS: ['true', '1', 'yes', 'on'].includes(String(process.env.REACT_APP_ENABLE_OFFICIAL_RECORDS || '').trim().toLowerCase()),
  
  // Timeouts
  API_TIMEOUT: 30000, // 30 segundos
  
  // Paginación
  DEFAULT_PAGE_SIZE: 20,
  
  // Notificaciones
  NOTIFICATION_DURATION: 5000,
};

export default config; 